export const formatPhoneNumber = (validPhoneNumber: string): string => {
    const normalizedNumber = validPhoneNumber.split("-").join("");
    let numberWithDashes = "";
    numberWithDashes += `${normalizedNumber.slice(0, 3) || ""}${normalizedNumber.length > 3 ? "-" : ""}`;
    numberWithDashes += `${normalizedNumber.slice(3, 6) || ""}${normalizedNumber.length > 6 ? "-" : ""}`;
    numberWithDashes += `${normalizedNumber.slice(6, normalizedNumber.length) || ""}`;
    return numberWithDashes;
};
